import React, { useState, useEffect, useRef, useContext } from "react";
import axios from 'axios';
import ItemApi from "../api/ItemApi";
import ItemForm from "./ItemForm";
import { ImCancelCircle } from "react-icons/im";
import { FaEdit } from "react-icons/fa";
import { MdDelete, MdInventory } from "react-icons/md";
import Pagination from "../component/paginations/pagination";
import ItemInventory from "./ItemInventory";
import SettingApi from "../api/SettingApi";
import { FiSearch } from "react-icons/fi";
import { SettingsContext } from "../Context/SettingContext";

const ItemList = ({ refresh, tab }) => {
  const [items, setItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [showInventoryDetails, setShowInventoryDetails] = useState(false);
  const taskDetailsRef = useRef(null);
  const [editItemId, setEditItemId] = useState(null);
  const [editType, setEditType] = useState(null);
  const {settings} = useContext(SettingsContext);
  const [searchQuery, setSearchQuery] = useState("");

useEffect(() => {
  const delayDebounceFn = setTimeout(() => {
    getItem();
  }, 300); 

  return () => clearTimeout(delayDebounceFn);
}, [searchQuery]);

  useEffect(() => {
    getItem();
  }, [refresh, currentPage, postsPerPage]);

  useEffect(() => {
    setShowDetails(tab);
  }, [tab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (taskDetailsRef.current && !taskDetailsRef.current.contains(event.target)) {
        setShowDetails(false);
        setShowInventoryDetails(false); // Close inventory details modal on outside click
      }
    };

    if (showDetails || showInventoryDetails) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDetails, showInventoryDetails]);



  const getItem = async () => {
    try {
      setLoading(true);
  
      // Call the API with pagination and search query
      const response = await axios.get('/wp-json/devs-accounting/v1/items/', {
        params: { 
          page: currentPage, 
          per_page: postsPerPage, 
          search: searchQuery
        },
      });
      const data = response.data;
      
  
      // Fallback to `ItemApi.index` if data is not retrieved
      // const fallbackData = await ItemApi.index();
  
      setItems(data.data || fallbackData.data || []); // Use API response or fallback data
      setTotalItems(data.total_items || fallbackData.total_items || 0);
      setTotalPages(data.total_pages || fallbackData.total_pages || 1);
    } catch (error) {
      console.error("Error fetching items:", error);
      setItems([]); // Reset items in case of error
      setTotalItems(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };
  

  const itemDelete = async (id) => {
    
    const confirmDelete = window.confirm("Are you sure you want to delete this item?");
    if (confirmDelete) {
      try {
        const res = await ItemApi.delete(id);
        if (res) {
          getItem();
        }
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
  };

  const toggleDetails = (itemType = null, itemId = null) => {
    setShowDetails(!showDetails);
    setEditItemId(itemId);
    setEditType(itemType); 
  };

  const toggleInventoryModal = (itemType = null,itemId = null) => {
    setShowInventoryDetails(!showInventoryDetails);
    setEditItemId(itemId);
    setEditType(itemType)
  };

  // const lastPostIndex = currentPage * postsPerPage;
  // const firstPostIndex = lastPostIndex - postsPerPage;

  // // Filter items based on search query
  // const filteredItems = items.filter(item =>
  //   item.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  // // Paginate the filtered items
  // const currentPosts = filteredItems.slice(firstPostIndex, lastPostIndex);

  const handlePostsPerPageChange = (e) => {
    const newPostsPerPage = parseInt(e.target.value);
    setPostsPerPage(newPostsPerPage);
    setCurrentPage(1); // Reset to the first page when changing posts per page
  };

  // console.log(editType);
  // console.log('all item',items);

  return (
    <div>
      <div className="mx-auto">
        <div className="flex justify-between items-center px-6 py-4 bg-white border-b">
          <div className="text-lg text-gray-500">
            <h1>All Items</h1>
          </div>
          <div className="flex gap-x-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Search items..."
              className="appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-[10px] px-4 ml-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="absolute right-2 top-[25%]">
              <FiSearch size={20} />
            </div>
          </div>
            <div>
              <button
                onClick={() => toggleDetails()}
                ref={taskDetailsRef}
                className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              >
                Add
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="p-4">
                        <div className="flex items-center">
                          <input
                            id="checkbox-all"
                            type="checkbox"
                            className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label htmlFor="checkbox-all" className="sr-only">
                            checkbox
                          </label>
                        </div>
                      </th>
                      <th scope="col" className="py-3 px-24 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Name
                      </th>
                      <th scope="col" className="py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Price
                      </th>
                      <th scope="col" className="p-4">
                        <span className="sr-only">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    {items.map((item, index) => (
                      <tr
                        className="hover:bg-gray-100 dark:hover:bg-gray-700"
                        key={index}
                      >
                        <td className="p-4 w-4">
                          <div className="flex items-center">
                            <input
                              id={`checkbox-table-${index}`}
                              type="checkbox"
                              className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                            <label htmlFor={`checkbox-table-${index}`} className="sr-only">
                              checkbox
                            </label>
                          </div>
                        </td>
                        <td className="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          <div className="flex items-center">
                            {item.image ? (
                              <img
                                src={item.image}
                                alt={item.name}
                                className="h-10 w-14 object-fill rounded"
                              />
                            ) : (
                              <img
                                src={`/wp-content/plugins/${item.folder_name}/src/img/placeholder.jpg`}
                                className="h-10 w-14 object-cover rounded"
                              />
                            )}
                            <span className="ml-2 px-3">{item.name}</span>
                          </div>
                        </td>
                        <td className="text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                           {item.sale_price ? `$${parseFloat(item.sale_price).toFixed(2)}` : ""}
                        </td>
                        <td className="p-3 text-sm font-medium float-right whitespace-nowrap flex my-auto">
                          <a
                            onClick={() => toggleDetails(item.type, item.id)}
                            href="#"
                            title="Edit"
                            className="text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                          >
                            <FaEdit />
                          </a>
                          <button
                            onClick={() => itemDelete(item.id)}
                            title="Delete"
                            className="ml-2 text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                          >
                            <MdDelete />
                          </button>
                          <button
                            onClick={() => toggleInventoryModal(item.type, item.id)}
                            title="Inventory"
                            className="ml-2 text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                          >
                            <MdInventory />
                          </button>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Pagination */}
          {items.length > 0 && (
            <div className="flex justify-end items-center mt-4 gap-4">
              <div className="flex  justify-end items-center border border-gray-300 rounded-lg px-4 py-1 bg-white shadow-sm">
                <p className="mr-2 text-gray-700">Per Page</p>
                <select
                  className="appearance-none pl-2 pr-5 py-1 text-gray-700 focus:outline-none focus:border-indigo-500"
                  value={postsPerPage}
                  onChange={handlePostsPerPageChange}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
                </select>
              </div>

              <Pagination
                totalPosts={totalItems}
                postsPerPage={postsPerPage}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                totalPages={totalPages}
              />
            </div>
          )}

          {/* Modals for Item Details and Inventory */}
          {showDetails && (
            <div
              className={`fixed z-10 top-8 md:top-8 right-0 w-full h-full shadow-2xl max-w-[50rem] bg-white transition-transform duration-300 overflow-y-auto ${showDetails ? 'transform translate-x-0' : 'transform translate-x-full'}`}
              ref={taskDetailsRef}
            >
              <div className="flex justify-between p-3">
                <a className="mt-2 !ml-2 text-2xl text-gray-400 cursor-pointer" onClick={() => toggleDetails()}>
                  <ImCancelCircle />
                </a>
              </div>
              <div className="">
                <ItemForm itemId={editItemId} type={editType} onSubmits={getItem} toggle={toggleDetails}/>
              </div>
            </div>
          )}

          {showInventoryDetails && (
            <div
              className={`fixed z-10 top-8 md:top-8 right-0 w-full h-full shadow-2xl max-w-[50rem] bg-white transition-transform duration-300 overflow-y-auto ${showInventoryDetails ? 'transform translate-x-0' : 'transform translate-x-full'}`}
              ref={taskDetailsRef}
            >
              <div className="flex justify-between p-3">
                <a className="mt-2 !ml-2 text-2xl text-gray-400 cursor-pointer" onClick={() => toggleInventoryModal()}>
                  <ImCancelCircle />
                </a>
              </div>
              <div className="p-4">
                <ItemInventory itemId={editItemId} type={editType}  />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ItemList;
